<!--
 * @Descripttion: 日历签到成功弹窗
 * @Author: Niu Chenxin
 * @Date: 2021-01-14 10:37:20
 * @LastEditors: Niu Chenxin
 * @LastEditTime: 2021-01-15 13:41:04
-->
<template>
  <div class="signMask" @touchmove.prevent @mousewheel.prevent>
    <div class="signContainer" v-if="signData">
      <span class="close" @click.stop="signClose">
        <img src="../../../assets/images/icon/close.png" alt />
      </span>
      <div class="signToastCenter">
        <img class="signToastImg" src="./../../../assets/images/Profile/signIn/dingzhi.png" />
        <span class="everyCode">
          +{{signData.signOkXyz}}
          <span>签到成功</span>
        </span>
      </div>
      <p class="tips">连续3、7签到还有额外奖励哦</p>
      <ul class="signItem">
        <li class="borderSpan">
          <span class="spans" :class="signData.totalDays>=1?'bright':''"></span>
          <div class="borderLine" :class="signData.totalDays>=2?'bright':''"></div>
          <span class="borderNumber">1</span>
        </li>
        <li class="borderSpan">
          <span class="spans" :class="signData.totalDays>=2?'bright':''"></span>
          <div class="borderLine" :class="signData.totalDays>=3?'bright':''"></div>
          <span class="borderNumber">2</span>
        </li>
        <li class="borderSpan">
          <span class="gift" :class="signData.totalDays>=3?'bright':''"></span>
          <div class="borderLine" :class="signData.totalDays>=4?'bright':''"></div>
          <span class="borderNumber">3</span>
        </li>
        <li class="borderSpan">
          <span class="spans" :class="signData.totalDays>=4?'bright':''"></span>
          <div class="borderLine" :class="signData.totalDays>=5?'bright':''"></div>
          <span class="borderNumber">4</span>
        </li>
        <li class="borderSpan">
          <span class="spans" :class="signData.totalDays>=5?'bright':''"></span>
          <div class="borderLine" :class="signData.totalDays>=6?'bright':''"></div>
          <span class="borderNumber">5</span>
        </li>
        <li class="borderSpan">
          <span class="spans" :class="signData.totalDays>=6?'bright':''"></span>
          <div class="borderLine" :class="signData.totalDays>=7?'bright':''"></div>
          <span class="borderNumber">6</span>
        </li>
        <li class="borderSpan">
          <span class="gift" :class="signData.totalDays>=7?'bright':''"></span>
          <span class="borderNumberT">7</span>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {

    }
  },
  props: {
    signData: {
      type: Object,
      default: null
    }
  },
  methods: {
    signClose () {
      this.$emit('getSignData', false);
    }
  },
}
</script>

<style lang="less" scoped>
@import './../../../assets/less/contents/calendar/calenSign.less';
</style>